import React from 'react';

import { Tr } from '@chakra-ui/react';

import CompositionGroupTable from './CompositionGroupTable';
import { formatCurrency, formatQuantity } from './formatters';
import { StyledTd, StyledTh } from './StyledTableCell';

export type AuxiliaryActivitiesGroupRow = {
  code: string;
  description: string;
  quantity: number;
  unit: string;
  unitPrice: number;
  hourlyCost: number;
};

type AuxiliaryActivitiesGroupTableProps = {
  data: AuxiliaryActivitiesGroupRow[];
};

const AuxiliaryActivitiesGroupTable: React.FC<AuxiliaryActivitiesGroupTableProps> =
  ({ data }) => {
    const totalHourlyCost = data.reduce(
      (total, item) => total + item.hourlyCost,
      0,
    );

    return (
      <CompositionGroupTable
        headerRows={
          <Tr>
            <StyledTh colSpan={2}>D - ATIVIDADES AUXILIARES</StyledTh>
            <StyledTh textAlign="center" width="90px">
              Quantidade
            </StyledTh>
            <StyledTh textAlign="center" width="90px">
              Unidade
            </StyledTh>
            <StyledTh textAlign="right" width="140px">
              Preço Unitário
            </StyledTh>
            <StyledTh textAlign="right" width="140px">
              Custo Unitário
            </StyledTh>
          </Tr>
        }
        bodyRows={
          <>
            {data.map((item) => (
              <Tr key={item.code}>
                <StyledTd width="1%" minWidth="50px" whiteSpace="nowrap">
                  {item.code}
                </StyledTd>
                <StyledTd
                  minWidth="220px"
                  whiteSpace="normal"
                  overflowWrap="break-word"
                  wordBreak="break-word"
                >
                  {item.description}
                </StyledTd>
                <StyledTd textAlign="center">
                  {formatQuantity(item.quantity)}
                </StyledTd>
                <StyledTd textAlign="center">{item.unit}</StyledTd>
                <StyledTd textAlign="right">
                  {formatCurrency(item.unitPrice)}
                </StyledTd>
                <StyledTd textAlign="right">
                  {formatCurrency(item.hourlyCost)}
                </StyledTd>
              </Tr>
            ))}

            <Tr>
              <StyledTd colSpan={5} textAlign="right" fontWeight="600">
                Custo total de atividades auxiliares
              </StyledTd>
              <StyledTd textAlign="right" fontWeight="600">
                {formatCurrency(totalHourlyCost)}
              </StyledTd>
            </Tr>
          </>
        }
      />
    );
  };

export default AuxiliaryActivitiesGroupTable;
